import { uniq } from "lodash";

export function safeJoin(values: string[], seperator: string): string {
  return uniq(values)
    .filter((x) => x)
    .join(seperator);
}
